/* eslint-disable no-unused-vars */
<template>
<div>
    <div>

    </div>

  <v-app id="inspire">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-overlay :value="overlay">
                <v-progress-circular
                  indeterminate
                  size="64"
                ></v-progress-circular>
              </v-overlay>
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title style="margin-left:120px;">Definir Nova senha </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-card-text>

               <v-form ref="form" v-model="formValid" lazy-validation>
                  <div   v-if=" ( this.falal !== null &&  !this.falal.includes('status'))"  class="msgError">{{ falal }}</div>
                  <v-text-field
                    label="Nova Senha"
                    v-model="user.senha"
                    :rules="[rules.required, rules.password_ , rules.password ]"
                    autocomplete="Nova Senha"
                    name="login"
                    :type="showSenha ? 'text' : 'password'"
                    :append-icon="showSenha ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="showSenha = !showSenha"
                  ></v-text-field>
                  <v-text-field
                    label="Confirmar senha"
                    v-model="user.confirmar"
                    :rules="[rules.required, rules.password_ , rules.password ]"
                    autocomplete="Confirmar senha"
                    name="login"
                    :type="showConfirmar ? 'text' : 'password'"
                    :append-icon="showConfirmar ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="showConfirmar = !showConfirmar"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn  block :disabled="!formValid" @click="RecuperarSenha()" color="primary">Definir Nova senha</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
       <v-snackbar
        v-model="showResult"
        :timeout="2000"
        color="red"
        top>
        {{ result }}
      </v-snackbar>
      <v-snackbar
        v-model="showResultSucesso"
        :timeout="4000"
        color="green"
        top>
        {{ result }}
      </v-snackbar>
    </v-content>
  </v-app>
</div>
</template>

<script>
import axios from '../../plugins/axios'
import { v4 as uuidv4 } from 'uuid'
const ls = require('local-storage')
export default {
  props: {
    source: String
  },
  data: () => ({
    formValid: true,
    conectionStatus: '',
    progresso: false,
    browser: '',
    showResult: '',
    showResultSucesso: false,
    result: '',
    email: '',
    overlay: false,
    resultUsuario: '',
    counter_: 0,
    rules: {
      required: value => !!value || 'Campo obrigatório.',
      /* sequential123: value => !value.includes('123') || 'A sequência 123 é invalida.',
      sequentialabc: value => !value.includes('abc') || 'A sequência abc é invalida.', */
      password_: value => value.length >= 8 || 'A password deve ter no minimo 8 caracteres',
      password: value => {
        const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/
        return (
          pattern.test(value) ||

            'A password deve ter ao menos uma letra maiúscula , minuscula e um número.'
        )
      }
    },
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'Máximo número de carácteres atigidos',
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    usernameRule: [
      // this.value.replace(/[^\d]/, ''),

      v => !!v || 'campo obrigatório.',
      v => {
        const pattern = /([^A-Za-z0-9])$/
        return !pattern.test(v) || 'Inválido.'
      }
    ],
    drawer: null,
    user: {
      senha: '',
      confirmar: ''
    },
    userDefault: {
      senha: '',
      confirmar: ''
    },
  long: '',
  lat: '',
  showSenha: false,
  showConfirmar: false
  }),

  computed: {
    loggedUser () {
      const user = this.$store.getters.loggedUser
      return user // this.$session.get("role")// this.$session.getAll()// this.$session.flash.get("role")
    },
    falal () {
      return ls.get('fatal')
    }

  },

  created () {
    this.CheckConection()
    console.log(this.conectionStatus)
    ls.set('mensagensDefault', [])
    this.browser = this.$browserDetect.meta.name
    this.ValidaCodigo(this.$route.query.idp)
  },

  methods: {

    CheckConection () {
      if (!navigator.onLine) { this.conectionStatus = 'Verifique a sua conexão de internet' }
    },

    async RecuperarSenha () {
      this.overlay = true

      if (!this.user.senha.includes("'") && !this.user.confirmar.includes('"')) {
        const userCredencial =
        {
          senha: this.user.senha,
          email: this.email
        }

        if (this.user.senha !== this.user.confirmar) {
          this.result = 'As senhas não correspondem'
          this.showResult = true
          this.overlay = false
        } else {
          // ---Restara a senha
          this.overlay = true
          try {
            let result = await axios
              .post('/recuperar-Senha', userCredencial)
              .then(res => res.data)

              console.log(result, ' a resposta GG');
              
            if (result.affectedRows >= 1) {
              this.result = 'A sua senha foi redifinida com sucesso'
              this.showResultSucesso = true
              this.user = this.userDefault
              setTimeout(() => {
              this.$router.push('/')
              }, 2000)
            }
            
            this.overlay = false
          } catch (error) {
            this.$store.dispatch('textMessage', { 'msg': 'Usuärio ou senha incorrecta !', 'classMessage': 'msgError', 'timeout': 3000 })
          } finally {
            console.log(error)
            this.overlay = false
          }
        }
      } else {
        this.$store.dispatch('usuario', { 'msg': 'Inválido !', 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async ValidaCodigo (codigo) {
      let params = {
        codigo: codigo
      }
      try {
        let result = await axios
          .post('/validaCodigo', params)
          .then(res => res.data)
        this.email = result.email
        if (result.email !== undefined) {

        } else {
          this.$router.push('/')
        }
        this.progresso = false
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': 'Usuärio ou senha incorrecta !', 'classMessage': 'msgError', 'timeout': 3000 })
      } finally {
        this.progresso = false
      }
    },

    async   ValidarEmail (userCredencial) {
      try {
        this.resultUsuario = await axios
          .post('/ValidarEmail', userCredencial)
          .then(res => res.data)
        this.progresso = false
        console.log(usuario)
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': 'Usuärio ou senha incorrecta !', 'classMessage': 'msgError', 'timeout': 3000 })
      } finally {
        this.progresso = false
      }
    }

  }

}
</script>
<style scoped>

</style>
